const INDICATOR_COLOR = { validated: "success", current: "primary", upcoming: null };

function progressStatus(stepIndex, persistedIndex) {
  if (stepIndex < persistedIndex) return "validated";
  if (stepIndex === persistedIndex) return "current";
  return "upcoming";
}

function StepItem({ step, index, progress, isViewed, isClickable, showCurrentBadge, isLast, onSelect }) {
  const color = INDICATOR_COLOR[progress];
  const indicatorClass = color ? `bg-${color} border-${color} text-white` : "border-secondary text-muted";

  return (
    <div
      role={isClickable ? "button" : "listitem"}
      aria-current={progress === "current" ? "step" : undefined}
      onClick={isClickable ? () => onSelect(step.id) : undefined}
      onKeyDown={
        isClickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onSelect(step.id);
              }
            }
          : undefined
      }
      tabIndex={isClickable ? 0 : undefined}
      className="d-flex position-relative px-3 py-2"
      style={{
        gap: "0.75rem",
        cursor: isClickable ? "pointer" : "default",
        background: isViewed ? "rgba(94,114,228,0.08)" : "transparent",
      }}
    >
      {isViewed && (
        <span
          aria-hidden
          className="position-absolute bg-primary"
          style={{ left: 0, top: 0, bottom: 0, width: "3px" }}
        />
      )}
      {!isLast && (
        <span
          aria-hidden
          className={`position-absolute ${color ? `bg-${color}` : "bg-secondary"}`}
          style={{
            left: "calc(1rem + 11px)",
            top: "calc(0.5rem + 22px)",
            width: "1px",
            height: "calc(100% - 22px)",
            opacity: 0.4,
          }}
        />
      )}
      <div
        className={`d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle border ${indicatorClass}`}
        style={{ width: "22px", height: "22px", fontSize: "0.7rem" }}
      >
        {progress === "validated" ? <i className="fas fa-check" /> : index + 1}
      </div>
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center" style={{ gap: "0.4rem" }}>
          <div
            className={`small ${progress === "upcoming" ? "text-muted" : ""} ${
              isViewed || progress === "current" ? "font-weight-bold" : ""
            }`}
          >
            {step.label}
          </div>
          {showCurrentBadge && (
            <small className="text-uppercase text-primary border border-primary rounded px-1">current</small>
          )}
        </div>
        {step.sub && <small className="text-muted d-block">{step.sub}</small>}
      </div>
    </div>
  );
}

function VerticalStepper({ steps, viewedStepId, persistedStepId, onSelect }) {
  const viewedIndex = steps.findIndex((s) => s.id === viewedStepId);
  const persistedIndex = steps.findIndex((s) => s.id === persistedStepId);
  const showCurrentBadgeAt = viewedIndex !== persistedIndex ? persistedIndex : -1;

  return (
    <div
      role="list"
      aria-label="Wizard steps"
      className="d-flex flex-column flex-shrink-0 py-3"
      style={{ width: "220px", borderRight: "1px solid rgba(255,255,255,0.08)" }}
    >
      {steps.map((step, i) => (
        <StepItem
          key={step.id}
          step={step}
          index={i}
          progress={progressStatus(i, persistedIndex)}
          isViewed={i === viewedIndex}
          isClickable={i <= persistedIndex}
          showCurrentBadge={i === showCurrentBadgeAt}
          isLast={i === steps.length - 1}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}

export default VerticalStepper;
